module.exports = __webpack_public_path__ + "img/jogo-toalhas.6f58a64a.png";